export default "__VITE_ASSET__abf511b5__"